/** Null inherits role policy; overrides cover staff and partner catalog users. */
export const staffFeatureKeys = ['skuCreate', 'skuEdit', 'skuPhotoUpload'];
export function staffFeatureAllowed(user, feature) {
    if (!user)
        return false;
    const roles = user.roles.map((r) => r.role);
    const admin = roles.includes('ADMIN');
    const staff = admin || roles.includes('OPERATOR');
    if (admin && user.ownerAdmin)
        return true;
    const override = user.staffFeatures?.[feature];
    const partnerUser = roles.includes('PARTNER_ADMIN') || roles.includes('ORDER_PLACER');
    if ((staff || partnerUser) && override != null)
        return override;
    return roles.includes('PARTNER_ADMIN') || admin || (feature === 'skuCreate' && staff);
}
//# sourceMappingURL=staff-features.js.map